import { Link, useNavigate } from 'react-router-dom';
import { Avatar, Menu } from '@mantine/core';
import { IconHistory, IconListSearch, IconLogout } from '@tabler/icons-react';
import { useEnrichedAuth } from '@/hooks/useEnrichedAuth';
import { AppearanceMenuItems } from './ThemeMenu';

/** Signed-in header: the person's photo or initials (48 px target) opening the account menu. */
export function AccountMenu() {
  const navigate = useNavigate();
  const { logout, getUserInitials, getUserDisplayName, user } = useEnrichedAuth();
  const name = getUserDisplayName();

  return (
    <Menu position="bottom-end" withinPortal width={250} offset={4}>
      <Menu.Target>
        <button type="button" className="proc-iconbtn" aria-label="Account menu">
          <Avatar
            component="span"
            size={36}
            radius="xl"
            color="brand"
            variant="light"
            src={user?.avatar || null}
            alt=""
            imageProps={{ referrerPolicy: 'no-referrer', draggable: false }}
            className="proc-avatar-ring"
          >
            {getUserInitials()}
          </Avatar>
        </button>
      </Menu.Target>
      <Menu.Dropdown>
        {name && <Menu.Label style={{ fontSize: 15, color: 'var(--proc-ink)', fontWeight: 700 }}>{name}</Menu.Label>}
        <Menu.Item leftSection={<IconListSearch size={18} />} component={Link} to="/">All procedures</Menu.Item>
        <Menu.Item leftSection={<IconHistory size={18} />} component={Link} to="/me/runs">My runs</Menu.Item>
        <Menu.Divider />
        <AppearanceMenuItems />
        <Menu.Divider />
        <Menu.Item
          leftSection={<IconLogout size={18} />}
          onClick={async () => {
            try {
              await logout();
            } finally {
              navigate('/');
            }
          }}
        >
          Sign out
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
